import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterModule} from "@angular/router";
import {LocaleService} from "../../../../services/locale.service";
import {distinctUntilChanged, Subscription} from "rxjs";
import {getAndValidateSelectedDateQueryParam} from "../../../../utlis/GetAndValidateSelectedDateQueryParam";
import {isValid} from "date-fns";
import {Backend} from "@generated-backend-types";
import OnlineShopFilterEnum = Backend.App.Enums.Settings.Article.OnlineShopFilterEnum;
import {environment} from "../../../../../environments/environment";
import {CoreModule} from "../../../core.module";
import {CollapseModule} from "ngx-bootstrap/collapse";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CoreModule, RouterModule, CollapseModule]
})
export class HeaderComponent implements OnInit, OnDestroy {
  public homeRouterLink: string = this.localeService.currentLocale;
  public dateSelected: boolean = false;

  public OnlineShopFilterEnum = OnlineShopFilterEnum;
  public mobileNavCollapsed: boolean = true;

  public vehicleConsultationEnabled = environment.vehicle_consultation_nav_enabled;

  private dateQueryScanner?: Subscription;

  public ngOnInit() {
    this.activatedRoute.queryParams.pipe(
      distinctUntilChanged((p, c) => p?.['date'] === c?.['date'])
    ).subscribe({
      next: value => {
        const date = getAndValidateSelectedDateQueryParam(value);
        this.dateSelected = isValid(date);
        this.cdr.markForCheck();
      }
    })
  }

  public ngOnDestroy() {
    this.dateQueryScanner?.unsubscribe();
  }

  public langChange(lang: 'de' | 'en') {
    this.homeRouterLink = lang;
    this.cdr.markForCheck();
    this.localeService.changeLocale(lang);
  }

  public constructor(
    public cdr: ChangeDetectorRef,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public localeService: LocaleService
  ) {
  }
}
